
<template>
  <div>
    <a-row>
      <a-col :span="12">
      </a-col>
      <a-col :span="12">
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Workplace',
  data () {
    return {

    }
  },
  methods: {
  },
  components: {
  }

}
</script>

<style lang="less" scoped>
.Calendar{
  background: #fff;
}

</style>
